import { Button } from '@travelnest/merlin.button';
import theme from '@travelnest/merlin.theme';
import { IEventNote } from 'data/entities/event/event-note';
import { startCase } from 'lodash';
import React from 'react';
import { canDeleteNote, formatNote, formatTimeStamp } from './helpers';

export interface IEventNotesListProps {
	eventNotes: IEventNote[];
	deleteEventNote: (EventNote: IEventNote) => void;
}

export const EventNotesList: React.FunctionComponent<IEventNotesListProps> = (props) => {
	const classList = ['event-notes-list__container', 'event-notes-list__container--expanded'];

	return <>
		{props.eventNotes.sort((a, b) => a.created_at > b.created_at ? -1 : 1).map((note, i) =>
			<div className={classList.join(' ')} key={i}>
				<div className="event-notes-list__summary">
					<section className="event-notes-list__column">
						<span>{note.created_at && formatTimeStamp(note.created_at) || 'New'}</span>
					</section>
					<section className="event-notes-list__column">
						<span>{startCase(note.note_type)}</span>
					</section>
				</div>
				<hr className="event-notes-list__separator" />
				<ul className="event-notes-list__list">
					<li>
						<span className="event-notes-list__note">
							{formatNote(note.note_type, note.content)}
						</span>
						{canDeleteNote(note) && <Button
							bgColor={theme.colours.error.default}
							color={theme.colours.text.lightest}
							hoverColor={theme.colours.error.misc}
							onClick={(event) => props.deleteEventNote(note)}>Delete</Button>}
					</li>
				</ul>
			</div>)}
	</>;
};
